import styled from 'styled-components';
import { Colors, Text, Row, Box } from 'basic-ui-lib';
import { IcArrowLeft } from 'basic-ui-lib/icons';
import { IMediaItem as ILibraryItem, MediaType } from 'modules/media/interfaces/api';
import MediaItemCard from '../MediaItemCard';

interface MediaTabContentProps {
  items: ILibraryItem[];
  currentPath: string;
  folderName: string;
  selectedMediaIds?: string[];
  onMediaItemClick: (item: ILibraryItem) => void;
  onBackClick: () => void;
}

const MediaTabContent = ({
  items,
  currentPath,
  folderName,
  selectedMediaIds,
  onMediaItemClick,
  onBackClick,
}: MediaTabContentProps) => {
  const currentFolderItemCount = items.length;

  return (
    <>
      {/* Folder Breadcrumb */}
      {currentPath && (
        <Row alignItems="center" gap={8} paddingBottom={16}>
          <BackButton onClick={onBackClick}>
            <IcArrowLeft width={20} height={20} fill={Colors.neutral.text[5]} />
          </BackButton>
          <Text body_1 semibold color="neutral.text.5">
            {folderName} Folder ({currentFolderItemCount})
          </Text>
        </Row>
      )}
      {items.length === 0 ? (
        <Box display="flex" alignItems="center" justifyContent="center" height={300}>
          <Text body_1 color="neutral.text.4">
            No media found
          </Text>
        </Box>
      ) : (
        <MediaGrid>
          {items.map((item) => (
            <MediaItemCard
              key={item.id}
              item={item}
              selected={item.type !== MediaType.FOLDER && selectedMediaIds?.includes(item.id)}
              onClick={() => onMediaItemClick(item)}
            />
          ))}
        </MediaGrid>
      )}
    </>
  );
};

export default MediaTabContent;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: ${Colors.neutral.bg[2]};
  }
`;

const MediaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;
